import { FrxBaseBean } from './frxbasebean';
import { Lawyer } from './Lawyer';

export class ExternalCase extends FrxBaseBean {
	number: string;
	scheduledDate: any;
	scheduledTime: string;
	lawyer: Lawyer;
	note: string;

	constructor() {
		super();
		this.lawyer = null;
	}
}

export class ExternalCaseSearch {
	number: string;
	lawyerId: number;
	dateFrom: any;
	dateTo: any;
	noteText: string;
	myOnly: boolean = true;
}
